/* eslint-disable indent */
import React from 'react'
import strings from 'utils/strings'
import styled from '@emotion/styled'
import { useDispatch } from 'react-redux'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import { LIST, DASH_VIEW } from 'utils/constants'
import { resetVehicleDash } from 'actions/dash'
import { Content, Footer } from 'components/SwitchAndGauge/DashDrawer/Sections'
import { Button, Paragraph, Icon, FlexRow, FlexCol } from 'components/patterns'
import { StyledViewWrap } from './style'

const ErrorView = () => {
  const dispatch = useDispatch()

  const handleReset = () => {
    dispatch(resetVehicleDash())
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  const handleCancel = () => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  return (
    <StyledViewWrap>
      <Content>
        <StyledResetErrorRow>
          <StyledIcon icon="exclamation-circle" width={12} fill="filled" />
          <StyledResetErrorColumn>
            <StyledParagraphOne size="large" weight="bold">
              {strings.part_and_location_conflict}
            </StyledParagraphOne>
            <StyledParagraphTwo size="small" weight="bold">
              {strings.error_caused_by_the_following}
            </StyledParagraphTwo>
            <StyledParagraphThree>{''}</StyledParagraphThree>
            <StyledParagraphFour>
              {strings.please_contact_chec_support_for_further_assistance}:{' '}
              <StyledSpanFive>{strings.chec_support_email}</StyledSpanFive>
            </StyledParagraphFour>
          </StyledResetErrorColumn>
        </StyledResetErrorRow>
      </Content>
      <Footer>
        <FlexRow>
          <FlexCol span={12}>
            <div>
              <Button type="danger" onClick={handleReset}>
                {strings.reset}
              </Button>
            </div>
          </FlexCol>
          <FlexCol span={12} alignItems="end">
            <div>
              <Button type="secondary" onClick={handleCancel}>
                {strings.cancel}
              </Button>
            </div>
          </FlexCol>
        </FlexRow>
      </Footer>
    </StyledViewWrap>
  )
}

export default ErrorView

const StyledIcon = styled(Icon)`
  order: 1;
  margin-top: 1%;
  font-size: 20px;
  padding-right: 8.5%;
`

const StyledParagraphOne = styled(Paragraph)`
  font-size: 20px;
  margin-bottom: 7%;
`

const StyledParagraphTwo = styled(Paragraph)`
  margin-bottom: 2.5%;
`

const StyledParagraphThree = styled(Paragraph)`
  margin-bottom: 2.5%;
  max-width: 350px;
`

const StyledParagraphFour = styled(Paragraph)`
  margin-bottom: 10%;
  max-width: 350px;
`

const StyledSpanFive = styled.span((props) => {
  const { blueSecondary } = props.theme.color

  return `
  display: inline;
  color: ${blueSecondary}
`
})

const StyledResetErrorRow = styled.div`
  margin-left: 3%;
  display: flex;
  flex-direction: row;
`

const StyledResetErrorColumn = styled.div`
  order: 2;
  display: flex;
  flex-direction: column;
`
